import { useQuery } from '@tanstack/react-query';
import { Membership } from '@/types/api/membership';
import api from '@/api';

type MembershipQueryKey = ['memberships', 'user'];

export function useMembershipsByUserQuery() {
  return useQuery<Membership[], Error, Membership[], MembershipQueryKey>({
    queryKey: ['memberships', 'user'],
    queryFn: () => api.membership.listByUser(),
  });
}
